import React from "react";
import PeopleProfileCard from "./PeopleProfileCard";
import SideBar from "./SideBar";
import img1 from "../../Images/Col_Molinero.jpeg"
import img2 from "../../Images/Col_JKSingh.jpeg"
import img3 from "../../Images/Col_Susant.jpeg"
import img4 from "../../Images/Col_AnikSen.jpeg"

const createElements = () => {
  const elements = [];
  const PeopleImagesUrl = [img1, img2, img3, img4];

  const PeopleName = [
    "Prof. Valeria Molinero",
    "Prof. Jayant K Singh",
    "Dr. Sushant Kumar",
    "Dr. Anik Sen",
  ];

  const Link = [
    "https://molinero.hec.utah.edu/index.php",
    "https://cnislab.com",
    "https://www.iitp.ac.in/index.php/people-12/faculty/2-uncategorised/303-view-profile-100",
    "https://vspgischemistry.gitam.edu/faculty/profile/500027",
  ];

  const PeopleEmailId = [
    "Valeria.Molinero@utah.edu",
    "jayantks@iitk.ac.in",
    "sushantkumar@iitk.ac.in",
    "asen@gitam.edu/anikchem@gmail.com",
  ];

  const PeopleDescription = [
    `Distinguished Professor
  Jack and Peg Simons Endowed Professor of Theoretical Chemistry
  Director, Henry Eyring Center for Theoretical Chemistry`,
    `Head of Chemical Engineering Department IIT Kanpur
    Prescience
    Poonam and Prabhu Goel Chair`,
    `Associate Professor
  Department of Chemical and Biochemical Engineering
  Indian Institute of Technology Patna`,
    `Assistant Professor
  Department of Chemistry
  Gitam Institute of Science`,
  ];

  for (var i = 0; i < PeopleName.length; i++) {
    elements.push(
      <PeopleProfileCard
        key={i}
        peopleImagesUrl={PeopleImagesUrl[i]}
        peopleName={PeopleName[i]}
        peopleEmailId={PeopleEmailId[i]}
        peopleDescription={PeopleDescription[i]}
        link={Link[i]}
      />
    );
  }
  return elements;
};

const Collaborators = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <SideBar collaborators = {true}/>
        </div>
        <div className="col-lg-9 padding-lg">
          <div className="heading mt-5"> Collaborators </div>
          <hr />
          <div className="row pt-2">{createElements()}</div>
        </div>
      </div>
    </div>
  );
};

export default Collaborators;
